import { Absenderinformationen } from "@/model/Absenderinformationen";

export class Korrespondenz {
  id = "";
  vorschlagDokument = "";
  antragDokument = "";
  dokumentName = "";
  vorschlagDokumentVorhanden = false;
  beilagen = "VOLLSTAENDIG";
  kopieAnMakler = false;
  absenderinformationen = new Absenderinformationen();
  //druckZuschlaegeNachlaesseList
  anfrageId = "";
  productId = "";
  //druckZuschlaegeNachlaesseProProdukt
}
